"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objSizeDisplay = exports.objSize = exports.byteSizeDisplay = exports.stopwatch = exports.findIndexes = exports.sleep = void 0;
function sleep(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
exports.sleep = sleep;
function findIndexes(arr, condition) {
    return arr.reduce(function (acc, cur, index) {
        if (condition(cur, index)) {
            acc.push(index);
        }
        return acc;
    }, []);
}
exports.findIndexes = findIndexes;
/**
 * Convenience function for when debugging,
 * to measure and log time - it's just a bit nicer than
 * using `console.time()` or `Date.now() - start`.
 * Usage:
 *
 * ```ts
 * const timer = stopwatch("Doing this...");
 * // ^ `prints [START] Doing this...`
 *
 * timer.logEnd();
 * // ^ prints `[END] Doing this...: Took 534ms.`
 * ```
 */
function stopwatch(initialMsg) {
    var startTime = Date.now();
    console.log("[START] ".concat(initialMsg));
    var endWasCalled = false;
    var end = function () {
        if (endWasCalled) {
            console.log('Timer has already ended.');
            return;
        }
        endWasCalled = true;
        var endTime = Date.now();
        return endTime - startTime;
    };
    var logEnd = function (message) {
        if (endWasCalled) {
            console.log('Timer has already ended');
            return;
        }
        var took = end();
        if (message) {
            console.log("[END] ".concat(initialMsg, " ").concat(message, ": Took ").concat(took, "ms."));
            return;
        }
        console.log("[END] ".concat(initialMsg, " finished. Took ").concat(took, "ms."));
    };
    return { end: end, logEnd: logEnd };
}
exports.stopwatch = stopwatch;
/**
 * Give this a number of bytes and it will return a prettier version.
 * e.g. give this `182,231` and it will return `182.231kb`.
 * @param obj The object you want to know the size of.
 */
function byteSizeDisplay(size) {
    if (size < 1e3)
        return "".concat(size, " bytes");
    // 100 for two places
    if (size < 1e6)
        return "".concat(Math.round(size / 1e1) / 100, " kb");
    return "".concat(Math.round(size / 1e4) / 100, " mb");
}
exports.byteSizeDisplay = byteSizeDisplay;
/**
 * Give this an object and it will tell you its byte size.
 * @param obj The object you want to know the size of.
 * @returns The size in bytes.
 */
function objSize(obj) {
    return Buffer.from(JSON.stringify(obj)).byteLength;
}
exports.objSize = objSize;
/**
 * Give this an object and it will return a formatted size with an
 * appropriate unit.
 * @param obj The object you want to know the size of.
 * @returns The size in bytes in a nice readable format.
 */
function objSizeDisplay(obj) {
    return byteSizeDisplay(objSize(obj));
}
exports.objSizeDisplay = objSizeDisplay;
